<mat-progress-bar class="mat-progress-bar-buffer" mode="indeterminate"></mat-progress-bar>
